export const COLORS = {
  ink: "#012442",
  paper: "#F9FAFB",
  danger: "#ff3100",
  white: "#ffffff",
  line: "rgba(1, 36, 66, 0.18)",
  inkSoft: "rgba(1, 36, 66, 0.74)",
};

export const SOFT_SHADOW =
  "0px 3px 3px rgba(0,14,51,0.25), 0px 1px 2px rgba(0,14,51,0.25)";

export const sxWrap = {
  display: "block",
  width: "100%",
  mx: 0,
};

export const sxCard = (hasProofFiles) => ({
  background: hasProofFiles ? "#f5f9fc" : COLORS.white,
  borderRadius: "16px",
  border: `1px solid ${COLORS.line}`,
  boxShadow: SOFT_SHADOW,
  position: "relative",
  overflow: "visible",
});

export const sxFlag = {
  position: "absolute",
  top: 12,
  right: 12,
  minWidth: 220,
  height: 38,
  px: 1.4,
  borderRadius: 999,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
  color: COLORS.ink,
  background: COLORS.paper,
  fontWeight: 600,
  letterSpacing: "0.2px",
  boxShadow: SOFT_SHADOW,
  border: `1px solid ${COLORS.line}`,
  zIndex: 10,
};

export const sxFlag2 = {
  position: "absolute",
  top: 0,
  right: 0,
  minWidth: 190,
  color: "#ffffff",
  height: 44,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
  background: "linear-gradient(180deg, #012442 0%, #00182d 100%)",
  borderRadius: "0 16px 0 20px",
  fontWeight: 700,
  fontSize: "0.95rem",
  textTransform: "uppercase",
  boxShadow: SOFT_SHADOW,
  zIndex: 10,
};

export const sxActionDock = {
  position: "absolute",
  top: 52,
  right: 12,
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
  zIndex: 11,
};

export const sxIconBtn = (tone) => ({
  width: 36,
  height: 36,
  borderRadius: "10px",
  border: `1px solid ${
    tone === "danger" ? "rgba(255,49,0,0.3)" : "rgba(1,36,66,0.18)"
  }`,
  background: "#ffffff",
  color: tone === "danger" ? COLORS.danger : COLORS.ink,
  boxShadow: SOFT_SHADOW,
  "&:hover": {
    background: "#F9FAFB",
    borderColor: tone === "danger" ? "rgba(255,49,0,0.55)" : "rgba(1,36,66,0.3)",
  },
});
